import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@/widgets/app-sidebar';
import { SidebarInset, SidebarProvider } from '@/shared/ui/shadcn/sidebar';

export function AppLayout() {
  return (
    <SidebarProvider className="h-svh overflow-hidden">
      <AppSidebar />
      <SidebarInset className="min-h-0 overflow-y-auto">
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  );
}
